import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../services/authentication.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
/**
 * @deprecated
 * @ignore
 */
@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {
  systemConfigs = [];

  constructor(private authenticationService: AuthenticationService, private http: HttpClient, private router: Router) { }

  ngOnInit() {
    // this.systemConfigs = this.authenticationService.getClientSystemList();
    // this.systemConfigs.map(config => {
    //   this.http.get(config.API).subscribe(data => {
    //     config.general = data;
    //   });
    //   return config;
    // });
  }

  openClient(clientConfig) {
    // this.authenticationService.getTokenForClient(clientConfig.API, clientConfig.clientId).subscribe(res => {
    //   this.router.navigateByUrl('/admin/client');
    // });
  }

}
